'use strict';

let isResolved, resolve;
let key = 'isFontsLoaded';
let trueValue = "1";

if (typeof(Storage) !== "undefined") {
    isResolved = () => {
        return sessionStorage[key] === trueValue;
    };
    resolve = () => {
        sessionStorage[key] = trueValue;
    }
} else {
    isResolved = () => {
        return false;
    };
    resolve = () => {

    }
}

export default {
    isResolved,
    resolve
}



// WEBPACK FOOTER //
// ./app/general/js/fonts-flag.js